import React, { useState } from 'react';
import '../../App.css';
import './tab-component.css';
import CSS from 'csstype';

// images
import { X as XIcon } from 'lucide-react';

// classes
import { AbbreviatedText } from '../../utils/functions';

//  --------------------------------------------------------------------------
//
//  C L A S S   D E F I N I T I O N
//
//  --------------------------------------------------------------------------

//  ------------------------------------------------------------
//
//  A tabbar, with a coloured background.
//
//  ------------------------------------------------------------

export const TabBar = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, role = 'navigation', children, ...rest }, ref) => {
  //
  const combinedClassName: string = ['tab-bar', 'text-colour', 'fr', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div ref={ref} role={role} className={combinedClassName} {...rest}>
      {children}
    </div>
  );
  //
});

//  ------------------------------------------------------------
//
//  A tab button, with an optional close button and a count.
//
//  ------------------------------------------------------------

export function TabButton(props: {
  text: string;
  onClick: any;
  onClose: any;
  number?: number;
  selected?: boolean;
  disabled?: boolean;
  index?: number;
}) {
  //
  //  --------------------------------------------------------------------------
  //
  //  R E D U X   S T A T E   H A N D L I N G
  //
  //  --------------------------------------------------------------------------

  //  --------------------------------------------------------------------------
  //
  //  D E C L A R A T I O N S
  //
  //  --------------------------------------------------------------------------

  //  ------------------------------------------------------------
  //
  //  C O M P O N E N T   C O D E
  //
  //  ------------------------------------------------------------

  return (
    <>
      {props.index !== 0 && props.index !== undefined && (
        <>
          <div style={{ flex: '0 0 8px' }} />
          <div className="tab-separator" style={{ flex: '0 0 8px' }} />
        </>
      )}
      <div
        className="tab"
        style={{
          flex: '1 1',
          display: 'flex',
          flexDirection: 'row',
        }}
        data-selected={props.selected ? 'T' : 'F'}
      >
        <button
          type="button"
          className="text-colour"
          style={{ flex: '1 1', backgroundColor: 'transparent', border: 'none' }}
          disabled={props.disabled}
          onClick={props.disabled ? undefined : props.onClick}
        >
          <AbbreviatedText text={props.text} />
        </button>
        {props.number !== undefined && (
          <div
            className="text-colour background-colour"
            data-invert="T"
            style={{
              flex: '0 0 auto',
              borderRadius: '8px',
              margin: '0px 8px',
              padding: '0px 20px 0px 20px',
            }}
          >
            {props.number}
          </div>
        )}
        {props.onClose !== undefined && (
          <button
            className="text-colour"
            type="button"
            style={{ flex: '0 0 auto', backgroundColor: 'transparent', border: 'none' }}
            onClick={props.disabled ? undefined : props.onClose}
          >
            <XIcon width={24} height={24} strokeWidth={1.5} />
          </button>
        )}
      </div>
    </>
  );
  //
} // TabButton
